import React from 'react';
import './side.css'
import Main from './table3'
import { getsitedata, logout } from "./../action/user";

function Side() {
  const onlogout = async () => {
    var test = await logout();
    window.location = "/";
  }
  return (
    <div className='row'>
      <div className='col-md-2'>

        <div className="sidebar">
          <a href='/myprofile'>My Profile</a>
          <a className="active" href='/showCard'>Viewed by me</a>
          <a href='/anotherviewed'>Viewed by others</a>
          <a href='/saved'>Favorite profiles</a>
          <a href='/membership'>Membership details</a>
          {/* <a href='/req-horoscope'>Request for Horoscope</a>
          <a href='/horoscope-reqs'>Horoscope Requests</a> */}
          <a onClick={onlogout}>Logout</a>
        </div>
      </div>
      <div className='col-md-10'>
        <div className="contents dopp" >
          <Main />
        </div>
      </div>
    </div>
  );
}
export default Side;